import ListingLocation from './ListingLocation';

export default ListingLocation;
